import { useCallback, useEffect, useState } from "react"

import { formatNumber } from "accounting"
import { Flex, Skeleton, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { selectKpi } from "../../redux/receipt.slice"

import styles from "./styles.module.less"

const { Text, Title } = Typography

// §BLOCK 2 — 4 non-interactive cards, respond to program selector.
const formatCurrency = (v) => "$" + formatNumber(v ?? 0, 2, ",")

export const KpiCards = ({ getReceiptKpi, isActive }) => {
  const { t } = useTranslation()
  const kpi = useSelector(selectKpi)
  const [loading, setLoading] = useState(false)

  const cards = [
    {
      key: "bank_inquiries",
      label: "Bank inquiries",
      subtitle: "Inquiries received from banks",
      value: formatNumber(kpi?.bankInquiries ?? 0, 0, ",")
    },
    {
      key: "match_rate",
      label: "Match rate",
      subtitle: "Inquiries with order matches",
      value: `${(kpi?.matchRate ?? 0).toFixed(1)}%`
    },
    {
      key: "lookup_fees",
      label: "Lookup fees",
      subtitle: "Fees charged to your balance",
      value: formatCurrency(kpi?.lookupFees)
    },
    {
      key: "dispute_amount_prevented",
      label: "Dispute amount prevented",
      subtitle: "Disputes avoided post-lookup",
      value: formatCurrency(kpi?.disputeAmountPrevented)
    }
  ]

  const handleGetReceiptKpi = useCallback(async () => {
    try {
      setLoading(true)
      await getReceiptKpi()
    } finally {
      setLoading(false)
    }
  }, [getReceiptKpi])

  useEffect(() => {
    if (isActive) void handleGetReceiptKpi()
  }, [handleGetReceiptKpi, isActive])

  return (
    <Flex gap={16} className={styles.grid}>
      {loading
        ? Array.from({ length: 4 }, (_, i) => (
            <Flex key={i} vertical gap={8} className={styles.card}>
              <Skeleton.Node active style={{ width: 120, height: 13, borderRadius: 4 }} />
              <Skeleton.Node active style={{ width: 72, height: 28, borderRadius: 4 }} />
              <Skeleton.Node active style={{ width: 160, height: 12, borderRadius: 4 }} />
            </Flex>
          ))
        : cards.map((c) => (
            <Flex
              key={c.key}
              vertical
              gap={4}
              align="start"
              className={styles.card}
              data-testid={`deflect-user-kpi-${c.key}`}
            >
              <Text
                ellipsis={{ tooltip: t(c?.label) }}
                type="secondary"
                strong
                style={{ fontSize: 14 }}
              >
                {t(c.label)}
              </Text>
              <Title level={3} style={{ margin: 0, fontSize: 28, fontWeight: 600 }}>
                {c.value}
              </Title>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {t(c.subtitle)}
              </Text>
            </Flex>
          ))}
    </Flex>
  )
}
